import Component from '../abstracts/Component';

export default class SearchComponent extends Component {

  get SELECTORS() {
    return {
      main: '[data-search]:not(.search-header)',
      icon: '.js-search-show',
      searchMain: 'main .search-header',
      searchHalfMedia: '.c-half-media .search-wrapper',
      searchClose: '.js-search-hide',
      header: '.main-header'
    };
  }

  get CLASSES() {
    return {
      visible: 'is-visible',
      searchOpened: 'search-opened'
      // isFirstVisible: 'is-first-visible',
    };
  }

  constructor() {
    super();
    this.main = $(this.SELECTORS.main);
    this.searchMain = $(this.SELECTORS.searchMain);
    this.searchShow = $(this.SELECTORS.main).data('searchShow');
    this.hideSearch = $(this.SELECTORS.main).data('searchHide');
    //
    this.searchIcon = document.querySelector(this.SELECTORS.icon);
    this.header = document.querySelector(this.SELECTORS.header);
  }

  // showInitial() {
  //   this.main.addClass(this.CLASSES.isFirstVisible);
  // }
  hideInitial() {
    this.searchMain.removeClass(this.CLASSES.visible);
  }

  bindGenericEvents() {

    this.$on('click.search', () => {
      this.$emit(this.$customEvents.SEARCH_EVENTS.toggle)
    }, this.searchShow);


    this.$on(this.$customEvents.SEARCH_EVENTS.toggle, () => {

      this.$emit(this.$customEvents.BACKDROP_EVENTS[isVisible ? 'hide' : 'show']);
      this.main.attr('aria-hidden', !this.main.attr('aria-hidden'));
      this.main.toggleClass(this.CLASSES.visible);
      //
      this.header.classList.add(this.CLASSES.searchOpened);
      //
      let isVisible = this.main.hasClass(this.CLASSES.visible);
      if (isVisible) {
        $(this.searchShow).addClass('not-visible').prop('disabled', true).hide();
        $('.header-actions .dropdown').addClass('not-visible').prop('disabled', true).hide();
        this.$emit(this.$customEvents.SEARCH_EVENTS.visible);
        $(this.main).find('input').focus();
        this.$on('click.search', () => {
          this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
          $(this.searchShow).show().removeClass('not-visible').prop('disabled', false);
          $('.header-actions .dropdown').show().removeClass('not-visible').prop('disabled', false);
          this.main.removeClass(this.CLASSES.visible);
          //
          this.header.classList.remove(this.CLASSES.searchOpened);
        }, this.hideSearch);
      } else {
        this.$off('click.search', this.hideSearch);
        $(this.searchShow).show().removeClass('not-visible').prop('disabled', false);
        $('.header-actions .dropdown').show().removeClass('not-visible').prop('disabled', false);

      }

    });


    const ctx = this;
    let top = 0;

    $(window).scroll(function() {
      let scroll = $(window).scrollTop();
        if(scroll > top) {
          ctx.searchMain.removeClass(ctx.CLASSES.visible);
          // I need to show search icon if hidden
          if (ctx.searchIcon !== null && ctx.searchIcon.classList.contains('hidden')) {
            ctx.searchIcon.classList.remove('hidden');
          }

      }
      top = scroll;
    });

  }

  inputChange() {
    const layerSearch = document.querySelector(this.SELECTORS.main);
    const bodySearch = document.querySelector(this.SELECTORS.searchMain);
    const bodySearchHalfMedia = document.querySelector(this.SELECTORS.searchHalfMedia);

    const mainElements = [layerSearch, bodySearch, bodySearchHalfMedia];

    mainElements.forEach(el => {
      if (!el) return;
      const input = el.querySelector(el.dataset.searchInput);
      const button = el.querySelector(el.dataset.searchSubmit);

      this.$on('keyup.search, paste', ({event}) => {
        let clipboardData = event.originalEvent.clipboardData;
        let fieldActualOrFutureValueIsNotBlank = event.currentTarget.value.trim() !== '' || (clipboardData && clipboardData.getData('Text').trim() !== '');
        if(fieldActualOrFutureValueIsNotBlank) {
          button.removeAttribute('disabled');
        } else {
          button.setAttribute('disabled', 'disabled');
        }
      }, input)
    });

  }

  render() {
    if (this.main.length === 0) return;
    this.bindGenericEvents();
    this.inputChange();

    if (this.$matchMedia('sm', null) && $('.c-half-media').length) {
      this.hideInitial();
    }

  }
}
